export default function makeChartOptions({
  vueScope,
  style = 'horizontal',
}): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
  const isHorizontal = style === 'horizontal'
  const colors = vueScope.$vuetify.theme.themes.light
  const week = ' Weeks'
  return {
    color: colors.teal,
    tooltip: { show: false },
    [isHorizontal ? 'xAxis' : 'yAxis']: {
      splitLine: {
        show: false,
        lineStyle: { color: colors.lightGrey },
      },
      interval: 7,
      name: '',
      nameLocation: 'center',
      nameGap: 40,
      nameTextStyle: {
        fontSize: 16,
        color: colors.black,
      },
      axisLabel: {
        margin: 16,
        color: colors.darkGrey,
        showMinLabel: { show: true },
        showMaxLabel: { show: true },
      },
      axisTick: {
        show: true,
        alignWithLabel: true,
      },
      data: [
        ('1' + week).replace('Weeks', 'Week'),
        2 + week,
        3 + week,
        4 + week,
        5 + week,
        6 + week,
        7 + week,
        8 + week,
        9 + week,
        10 + week + '+',
      ],
    },
    [isHorizontal ? 'yAxis' : 'xAxis']: {
      splitLine: {
        show: true,
        lineStyle: { color: colors.mediumGrey },
      },
      name: '# of Patients',
      nameLocation: 'center',
      nameGap: 10,
      nameTextStyle: {
        fontSize: 14,
        color: colors.black,
      },
      axisTick: { show: false },
      max: 20,
      splitNumber: 1,
    },
    series: [
      {
        type: 'bar',
        // @ts-ignore
        silent: true,
        label: {
          color: colors.darkGrey,
          show: true,
          position: isHorizontal ? 'top' : 'right',
          formatter: params => {
            return params.data === 0 ? '' : params.data
          },
        },
        itemStyle: {
          barBorderRadius: [4, 4, 0, 0],
        },
        markLine: {
          silent: true,
          precision: 0,
          symbol: [],
          label: { show: false },
          lineStyle: { width: 2 },
          data: [
            {
              [isHorizontal ? 'xAxis' : 'yAxis']: 3,
            },
          ],
        },
        data: [0, 0, 0, 0, 0, 0, 0, 1, 2, 17],
      },
    ],
  }
}

export function makeVerticalChartOptions({ vueScope }): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
  return makeChartOptions({ vueScope, style: 'vertical' })
}

export function makeHorizontalChartOptions({ vueScope }): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
  return makeChartOptions({ vueScope, style: 'horizontal' })
}
